export default __webpack_public_path__ + "static/media/Genitals.a532b538.svg";